<template>
  <moe-page>
    <moe-top></moe-top>
    <div class="coupon_box flex Flexjustify Flexalign">
      <div class="coupon_content">
        <div class="menu_list">
          <div class="flex">
            <div class="menu_one flex flexcolumn Flexalign cursor_pointer" v-for="(item, index) in menuList" :key="index"
              @click="chaneMenu(item)" :class="{ active_menu: selectMenu == item.value }">
              {{ item.label }}
            </div>
          </div>
          <div class="account_info flex mar_bottom_20" v-if="selectMenu == 1">
            <div class="account_label">当前登录账号：</div>
            <div class="account_value">
              <div class="account_name">{{userInfo.name}}</div>
              <div class="account_text">学习记录以当前账号为准</div>
            </div>
          </div>
        </div>
        <div class="content">
          <personalData v-if="selectMenu == 0"></personalData>
          <accountSetting v-if="selectMenu == 1"></accountSetting>
        </div>
      </div>
    </div>
  </moe-page>
</template>

<script>
import accountSetting from "./components/accountSetting.vue";
import personalData from "./components/personalData.vue";
import { mapState } from "vuex";
export default {
  name: "GjkcH5Setting",
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
  },

  components: {
    personalData,
    accountSetting,
  },
  data() {
    return {
      menuList: [
        { label: "资料设置", value: 0 },
        { label: "账号设置", value: 1 },
      ],
      selectMenu: 0,
    };
  },

  mounted() { },

  methods: {
    chaneMenu(info) {
      this.selectMenu = info.value;
    },
  },
};
</script>
<style lang="scss" scoped>
.coupon_box {
  width: 100%;
  min-height: calc(100vh - $pageTopHeight);
  background: #f3f3f3;

  .coupon_content {
    margin-top: 20px;
    box-sizing: border-box;
    width: $pageMainWidth;
    min-height: 966px;
    background: #ffffff;
    border-radius: 10px;
    padding: 20px;

    .menu_list {
      border-bottom: 1px solid rgba(20, 20, 20, 0.1);

      .menu_one {
        line-height: 50px;
        margin-right: 20px;
        font-size: 18px;
        position: relative;
      }

      .active_menu {
        font-weight: bold;
        color: #13d6aa;
      }

      .account_info {
        margin-top: 20px;

        .account_label {
          color: #333333;
          width: 120px;
          font-weight: 600;
        }

        .account_value {
          .account_name {
            color: #333333;
            font-weight: 600;
          }

          .account_text {
            font-size: 14px;
            color: #999999;
            margin-top: 12px;
          }
        }
      }
    }
  }
}
</style>